import React from 'react';
import { useWallet } from '../utils/walletContext';

/**
 * WalletDetector component
 * 
 * This component acts as a wrapper to handle cases where MetaMask or other
 * Ethereum wallets are not available in the browser. It shows a friendly
 * message to users without a wallet while still allowing them to browse
 * the site and use non-blockchain features.
 */
const WalletDetector = ({ children }) => {
  const { isWalletAvailable } = useWallet();

  // Show the No-wallet notification banner if wallet is not available
  const renderNoWalletBanner = () => {
    return (
      <div className="bg-orange-100 border-l-4 border-orange-500 text-orange-700 p-4 fixed top-24 left-0 right-0 z-50 shadow-md">
        <div className="container mx-auto flex items-start">
          <div className="rounded-full bg-orange-200 p-1.5 mr-3 flex-shrink-0">
            <svg className="w-5 h-5 text-orange-700" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
            </svg>
          </div>
          <div>
            <p className="font-medium">No Web3 Wallet Detected</p>
            <p className="text-sm mt-1">
              To use blockchain features of this site, please install{' '}
              <a 
                href="https://metamask.io/download/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="font-medium underline hover:text-orange-800"
              >
                MetaMask
              </a>{' '}
              or another Ethereum wallet. You can still browse the site and use non-blockchain features.
            </p>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {!isWalletAvailable && renderNoWalletBanner()}
      {children}
    </>
  );
};

export default WalletDetector;